import $ from 'jquery';
import {_str} from 'h2g-test-results/js/util';
import c11n from 'wtg/c11n';

export var __orbit = function() {
 var L = WTG.L;
 var that = this;
 this.d = {
  w:undefined, h:undefined,
  orbit:undefined,
  //t - title
  //t_id - string ids for the titles. use these ids to fetch from stringz while creating orbit
  orbiters: {
   device: {n:"device", t:"test_result_header_device", t_id:"test_result_header_device", e:"unknown",b:"unknown",index:0,img:"img/home_device_TDC.svg",reportScreenIcon:"img/rs_device.png",headerBgImg:"img/bg_device.jpg",pos:0},
   network: {n:"mobile_bs", t:"test_result_header_base_station", t_id:"test_result_header_base_station", e:"unknown",b:"unknown",index:1,img:"img/home_network_TDC.svg",reportScreenIcon:"img/rs_network.png",headerBgImg:"img/bg_network.jpg",pos:90},
   internet: {n:"internet", t:"test_result_header_internet", t_id:"test_result_header_internet", e:"unknown",b:"unknown",index:2,img:"img/home_internet_TDC.svg",reportScreenIcon:"img/rs_internet.png",headerBgImg:"img/bg_internet.jpg",pos:180},
   router: {n:"wifi_router", t:"test_result_header_wifi_router", t_id:"test_result_header_wifi_router", e:"unknown",b:"unknown",index:3,img:"img/home_router_TDC.svg",reportScreenIcon:"img/rs_router.png",headerBgImg:"img/bg_router.jpg",pos:270}
  }
 };
 this.arcData = {'device_router':{state:'unknown'},'internet_router':{state:'unknown'},'device_network':{state:'unknown'},'network_internet':{state:'unknown'}};
 this.ConnectionLineColors={
  unknown: "#C5C5C5",
  "ok": "#B7E200",
  "warn": "#FAAA0C",
  "prob": "#F52201",
  "skip": "#C5C5C5"
 };
 this.bgImgArc="img/bg_internet.jpg";
 var myCanvas;
 var sWidthF;
 var canvasHalf;
 var canvasExt;
 var ringDimension;
 var canvasRadius;
 var imageCenter;
 var offsetRegion;
 this.vHeight = 0;
 this.radius = 0;
 
 //Get orbiters count
 this.getOrbitersCount = function() {
  return Object.keys(this.d.orbiters).length;
 };
 this.setup = function() {
  var html = `<div class="canvasContainer">
   <div id="vpnOrbit"></div>
   <div id="circlecontainer"  style="position:relative"></div>
   <div id="showWarning" style="display:none;">
    <div class="resultSummaryInner" id="vpnStatus" style="margin-top:13%">
     <div id="vpnStatusMsg"> </div>
     <div id="vpnConnectedSer"> </div>
    </div>
    <div class="resultSummaryInner" id="networkStatus">
     <div>
      <span id="updateWarningInfo" class="fontFamilyBold showLimitedLines limited_lines" style="cursor:pointer"></span>
      <div style="height:7%;"></div>
      <span id="updateTapInfo" class="font_12 fontFamilyRegular showEllipses"></span>
     </div>
    </div>
   </div>
  </div>`;
  return html;
 };
 this.create = function(parent,cb) {
  $(parent).html(this.setup());
  this.setStatus();
  var sWidth =  $(parent).width() || 200;
  var sHeight = $(parent).height() || 200;  
  var lineHeight= Math.round(sHeight*.135);
  $("#circlecontainer").html(' <canvas id="myCanvasId" class="rotating" style=""></canvas>');
  sWidthF =  this.calculateOrbitWidth(sWidth,sHeight);
  this.radius =Math.round(sWidthF/2);
  $("#circlecontainer").css('width',sWidthF+'px').css('height',sWidthF+'px');
  this.vHeight = c11n.features.vpn ?  sWidthF/3+15 : 0;
  $("#showWarning").css('width',sWidthF+'px').css('height',sWidthF+'px');
  $("#showWarning").css({position:"absolute", top:this.vHeight+"px"});
  $(".canvasContainer").css('width',sWidthF+'px').css('height',sWidthF+this.vHeight+'px');
  $("#mainScreen_help_text").html( "help_text_tdc");
  ringDimension= Math.round(sWidthF*.28);
  imageCenter= Math.round(ringDimension*.93);
  offsetRegion = Math.round(imageCenter/1.6);
  canvasHalf= Math.round(sWidthF/2-offsetRegion); 
  canvasExt = Math.round(sWidthF/2+offsetRegion); 
  if(c11n.features.vpn) {
   this.addVpnOrbit();
  }
  else {
   $("#vpnStatus").css("visibility","hidden");
   $("#vpnOrbit").css("display","none");
   $('#deviceToRouter').remove();
   $('#routerToInternet').remove();
   $(".internetClass").attr("src","img/Unified/home_internet.svg");
  }

  $('#StatusTextId').css('line-height',lineHeight+'px');
  $('#UserStatusTextId').css('line-height',lineHeight+'px');
  
  myCanvas = document.getElementById("myCanvasId");
  myCanvas.width=sWidthF+6;
  myCanvas.height=sWidthF+6;

  this.d.orbit = new this.orbit();
  this.d.orbit.init("circlecontainer", this.radius, cb);
  var step = 360.0/this.getOrbitersCount();
  var angle = -step;

  for(var o in this.d.orbiters){
   this.d.orbiters[o].t = this.d.orbiters[o].t_id;
   this.d.orbit.addOrbiter(o, this.d.orbiters[o].t, angle+=step, this.d.orbiters[o].e,this.d.orbiters[o].b,this.d.orbiters[o].img);
  }
  $('#myCanvasId').click(function (e) {
   /*Here we divide canvas area into 4 parts for 4 arcs
   and in that we divide one of the part (for eg: wifi - arc connecting device and router) into three sub-parts and one is arc surrounded area where the click event
   is added (else condition) and remaining parts where the click event is excluded (if condition part).

   here x and y returns offset regions for adding click events to canvas area.

   and offsetRegion is half of the component(component is device, router, network, internet) width, as the click area of the arc should be excluding half of these components
   canvasExt -> half of the canvas width + offsetRegion
   canvasHalf -> half of the canvas width - offsetRegion

   We took those four(var touchAreaLimitX,var touchAreaLimitY,var touchAreaX,var touchAreaY) variables to
   subtract and add some values based on the various devices dimensions and
   to get more accuracy for click event on the arc.*/
   var x = e.offsetX;
   var y = e.offsetY;
   //offset regions for adding click events to canvas area
   var touchAreaLimitX=2;
   var touchAreaLimitY=4;
   var touchAreaX=3;
   //this part is related to wifi(bottom right arc)
   L.trace({fixed_line:that.d.orbiters.fixed_line},"fixed line something");
   if((x>canvasExt-touchAreaLimitX) && x <(sWidthF-touchAreaLimitY) && (y>(canvasExt-touchAreaLimitX) && y<(sWidthF-touchAreaLimitY))){
    if((x>canvasExt-touchAreaLimitX) && x <(sWidthF-offsetRegion) && (y>(canvasExt-touchAreaLimitX) && y<(sWidthF-offsetRegion))){
     // eslint-disable-line no-empty
    }
    else cb("wifi",that.arcData.device_router.state);
   }
   //this part is related to fixed_line(top right arc)
   else if((x>(canvasExt-touchAreaLimitX) && x <(sWidthF-touchAreaLimitY)) && (y>touchAreaLimitY && y<(canvasHalf+touchAreaX))){
    if((x>(canvasExt-touchAreaLimitX) && x <(sWidthF-offsetRegion)) && (y>(canvasHalf-offsetRegion) && y<(canvasHalf+touchAreaX))){
     // eslint-disable-line no-empty
    }
    else cb("fixed_line",that.arcData.internet_router.state);
   }
   //this part is related to mobile(bottom left arc)
   else if((x>touchAreaLimitY && x <(canvasHalf+touchAreaX)) && ((y>canvasExt-touchAreaLimitX) && y<(sWidthF-touchAreaLimitY))){
    if((x>(canvasHalf-offsetRegion) && x <(canvasHalf+touchAreaX)) && (y>(canvasExt-touchAreaLimitX) && y<(sWidthF-offsetRegion))){
     // eslint-disable-line no-empty
    }
    else cb("mobile",that.arcData.device_network.state);
   }
   //this part is related to mobile_backbone(top left arc)
   else if((x>touchAreaLimitY && x<(canvasHalf+touchAreaX)) && (y>touchAreaLimitY && y<(canvasHalf+touchAreaX))){
    if((x>(canvasHalf-offsetRegion) && x <(canvasHalf+touchAreaX)) && (y>(canvasHalf-offsetRegion) && y<(canvasHalf+touchAreaX))){
     // eslint-disable-line no-empty
    }
    else cb("mobile_bb",that.arcData.network_internet.state);
   }
  });
  $('#networkStatus').click(function (/*e*/) {
    cb("issues","summary");
  });
 };
 this.addVpnOrbit = function(){
  var template = '<div id="vpnOrbitRing"><div  class="ring unknown" id="sOrbit" style="text-align:center;"><img id="corpServerIcon" class="imageAlignementClass"  src="" /></div></div><div id="vpnOrbitLine"><div id="vpnOrbitArc"><img class="lockImg"  src="img/lockIcon.svg" /></div></div>';
  $("#vpnOrbit").css("display","block");
  $("#vpnOrbit").html(template);
  $("#vpnStatus").css("visibility","visible");
  $("#vpnOrbit").css('width',sWidthF+'px').css('height',this.vHeight+'px');
  $("#vpnOrbitRing").css('width',sWidthF+'px').css('height',(ringDimension/2)+'px');
  $("#vpnOrbitLine").css('width',sWidthF+'px').css('height',(this.vHeight-ringDimension)+'px');
  $(".ring").css('width',ringDimension+'px').css('height',ringDimension+'px');
  var sorbit_left =  Math.round(this.radius-($("#sOrbit").outerWidth()/2.0));
  $("#sOrbit").css({position:"absolute",left:sorbit_left+"px", top:-(ringDimension/2)+"px"});
  $("#vpnOrbitArc").css({position:"absolute",left:this.radius-3+"px",width:"6px",height:(this.vHeight-ringDimension)+"px"});
 };
 //Orbit: Orbit around which orbiters revolutes
 this.orbit = function() {
  this.cont = undefined;
  this.prop = {w:undefined, h:undefined, r:undefined, orbiters:{}};
  this.angler = {};
  this.count = 0;
  this._cb;

  // Initialize the orbit
  this.init = function(container, radius, cb) {
   // Pre-calculate angle mapping from degrees to radians
   var factor = Math.PI/180.0;
   for(var angled=0; angled<=360; angled++) {
       this.angler[angled] = angled*factor;
   }
   this.cont = $("#"+container);
   this.prop = {w:this.cont.width(), h:this.cont.height(), r:radius, orbiters:{}};
   this._cb = cb;
  };

  // Add an orbiter
  this.addOrbiter = function(id, title, angle, evaluation, getValue, images) {
   this.cont.append('<div  class="ring '+evaluation+' orbiterBorder"  style="text-align:center;" id="'+id+'"><img class="imageAlignementClass '+id+'Class"  src="'+images+'" /></div>');
   $(".ring").css('width',ringDimension+'px').css('height',ringDimension+'px');    
   $(".imageAlignementClass").css('width','55%').css('height','55%');
   var o = new that.orbiter(this.angler);
   o.init(id, this.prop.w/2, this.prop.h/2, this.prop.r, angle, this._cb, getValue);
   this.prop.orbiters[id] = {title:title, o:o, e:undefined};
   this.setStatusX(id, evaluation);
   this.count++;
  };

  // Position it to the angle specified in a specific direction
  this.position = function(clock, angle) {
   var c = 0;
   for(var orbiter in this.prop.orbiters) {
    this.prop.orbiters[orbiter].o.revolute((clock?(-1):1)*(angle?angle:(360.0/this.count)), (this.count==++c)?this._cb:null);
   }
   this._cb();
  };

  // Change evaluation status
  this.setStatusX = function(id, evaluation) {
   if(evaluation===undefined) return;
   var o = $("#"+id);
   if(this.prop.orbiters && this.prop.orbiters[id] && this.prop.orbiters[id].e) {
    o.removeClass(this.prop.orbiters[id].e);
   }
   this.prop.orbiters[id].e = evaluation;
   //L.trace('orbit-setstatus-evaluation-'+evaluation);
   o.addClass(evaluation);
   that.d.orbiters[id].e = evaluation;
  };
  
  this.changeArcColor = function(sNode,eNode,evalValue){
   var myCanvas = document.getElementById("myCanvasId");
   if(!myCanvas) return;
   var context= myCanvas.getContext("2d");
   
   var index1 = that.d.orbiters[sNode].index;
   var index2 = that.d.orbiters[eNode].index;
   var ArcIcon1 = that.d.orbiters[sNode].img;
   var ArcIcon2 = that.d.orbiters[eNode].img;
   if((index2-index1 == 1) || (index2-index1 == -1) || (index1==0 && index2==that.getOrbitersCount()-1) || (index1==that.getOrbitersCount()-1 && index2==0)) {
    var id = (index1 < index2)?sNode+'_'+eNode:eNode+'_'+sNode;
    var obj = {};
    obj.state =  evalValue;
    obj.ArcIcon1 =  ArcIcon1;
    obj.ArcIcon2 =  ArcIcon2;
    that.arcData[id] =  obj;
    var bSwapIndex;
    if(index1==0 && index2==that.getOrbitersCount()-1) bSwapIndex = true;
    else if(index1==that.getOrbitersCount()-1 && index2==0) bSwapIndex = false;
    else if(index1>index2) bSwapIndex = true;
    else bSwapIndex = false;
    
    var n1 = 360/that.getOrbitersCount();
    var sAngle = that.p[bSwapIndex?index2:index1].a;
    var eAngle = that.p[bSwapIndex?index1:index2].a;	
    
    var rd1 = ((sAngle/n1)/(that.getOrbitersCount()/2))+0.587;
    var rd2 = ((eAngle/n1)/(that.getOrbitersCount()/2))+0.413;

    context.lineWidth= 3;

    context.beginPath();
    context.arc(canvasRadius+3, canvasRadius+1, canvasRadius,rd1*Math.PI,rd2*Math.PI);
    context.strokeStyle= that.ConnectionLineColors[evalValue];
    context.stroke();
    context.closePath();
   }
   else L.warn('invalid nodes');
  };
 };
 this.p=[];
 //Orbiter: Object orbiting around the center
 this.orbiter = function(angler) {
  var myCanvas = document.getElementById("myCanvasId");
  var context= myCanvas.getContext("2d");
  var connector={"unknown":"#C5C5C5","ok":"#B7E200","warn":"#FAAA0C","prob":"#F52201"};
  // Properties: identifier, centre point of the orbit, radius of the orbit, angle at which the object is placed
  var prop = {id:undefined, c:{x:undefined,y:undefined}, r:undefined, a:undefined, s:{w:undefined,h:undefined}};
  // Initialize the orbiter with properties and animate to its angled position
  this.init = function(id, x, y, radius, angle, cb,getValue) {
   // Initialize with properties
   canvasRadius = Math.round(sWidthF/2);
   var o = $("#"+id);
   prop = {id:id, c:{x:x,y:y}, r:radius, a:Math.round(angle), s:{w:o.outerWidth(),h:o.outerHeight()}};
   that.p.push(prop);
   // Position the orbiter at centre
   o.css({position:"absolute", left:x-(prop.s.w/2.2), top:y-(prop.s.h/2.1)});
   // Animate slowly to its angled position 
   this.animate(prop.a, true);
   // Draw arcs depending on number of elements  	
   context.lineWidth= 3;
   context.beginPath();
   var n = 360/that.getOrbitersCount();
   var sAngle = ((prop.a/n)/(that.getOrbitersCount()/2))+0.587;
   var eAngle = (((prop.a+n)/n)/(that.getOrbitersCount()/2))+0.413;
   
   context.arc(canvasRadius+3,canvasRadius+1,canvasRadius, sAngle*Math.PI,eAngle*Math.PI);
   context.strokeStyle=connector[getValue];
   context.stroke();
   context.closePath();
   
   // Click on the orbiter would call the orbit callback to position
   o.click(function(){
    for(var o in that.d.orbiters) {
     if(prop.a == that.d.orbiters[o].pos) {
      cb(that.d.orbiters[o].n,that.d.orbiters[id].e);
      break;
     }
    }
   });
  };
  
  // Animate to its angled position
  this.animate = function(angled, slow, cb) {
   var pos = {left:Math.round(prop.r*Math.sin(-1*angler[angled])+prop.c.x-(prop.s.w/2.2)), top:Math.round(prop.r*Math.cos(-1*angler[angled])+prop.c.y-(prop.s.h/2.1))};
   $("#"+prop.id).animate(pos, slow?"slow":1, 'swing', cb);
  };
   
  // Revolute to the angle specified
  this.revolute = function(angle, cb) {
   var angler = {};
   var o = new that.orbiter(angler);
   o.changeArcAngle(angle);
   var neg = angle<0?true:false;
   angle = prop.a+Math.round(angle);
   if(angle < 0) angle += 360;
   angle = angle%360;
   prop.a = prop.a%360;
   var that = this;
   setTimeout(function() {
    var angled;
    if(neg) {
     if(prop.a > angle) for(angled=prop.a; angled>=angle; angled-=8) that.animate(angled);
     else {
      for(angled=prop.a; angled>=0; angled-=8) that.animate(angled);
      for(angled=360; angled>=angle; angled-=8) that.animate(angled);
     }
    }
    else {
     if(prop.a < angle) for(angled=prop.a; angled<=angle; angled+=8) that.animate(angled);
     else {
      for(angled=prop.a; angled<=360; angled+=8) that.animate(angled);
      for(angled=0; angled<=angle; angled+=8) that.animate(angled);
     }
    }
    prop.a = angle;
    that.animate(angle, false, cb);
   }, 1);
  };
 };
 this.calculateOrbitWidth = function (sWidth,sHeight){
  var isPortrait = sHeight > sWidth;
  var per=isPortrait ? 65 : 45;
  var orbit_width = 0;
  var orbit_height= 0;
  var other_controls_height = 100;
  var top_header = 8; //For TDC considered 15% for top_header(including tabs container).For h2g considered 8% as it wont have tabs but top header.
  var bottom_text = 15;// considered 15% for bottom text
  var margins = 20; //considered 20% for all margins.
  var corp = c11n.features.vpn?15:0; //For corporate version considered 15% to show corporate icon above the main circle.
  other_controls_height -= (top_header + bottom_text + margins + corp);
  if(isPortrait){
   orbit_width = Math.round(sWidth*per/100);
   var avail_height = Math.round(sHeight*other_controls_height/100);
   return Math.min(avail_height,orbit_width);
  }
  per -= c11n.features.vpn?15:0;
  orbit_height = Math.round(sHeight*per/100);
  var avail_width = Math.round(sWidth*.90); // 10% for margins
  return Math.min(avail_width,orbit_height);
 };
 this.showSummary = function(warningInfo,tapInfo) {
  if(warningInfo || tapInfo) $("#showWarning").show();
  else $("#showWarning").hide();
  $("#updateWarningInfo").text(warningInfo);
  $("#updateTapInfo").text(tapInfo);
 };
 this.setStatus = function(errors,warnings,status) {
  $("#networkStatus").css("margin-top","0px");
  $("#updateWarningInfo").removeClass("font_22");
  if(status) {
   this.showSummary(status,"");
   return;
  }
  if(errors) this.showSummary(WTG.fmt(((errors>1)?_str('str_problems_found'):_str('str_problem_found')),{errors:errors}),
  _str('str_tap_to_expand'));
  else if(warnings) this.showSummary(WTG.fmt(((warnings>1)?_str('str_warnings_found'):_str('str_warning_found')),{warnings:warnings}),
  _str('str_tap_to_expand'));
  else {
   $("#networkStatus").css("margin-top","10px");
   $("#updateWarningInfo").addClass("font_22");
   this.showSummary(_str('str_all_good'),_str('str_no_problem_found'));
  }
 };
};

export var WTGFIXEDLINE = function(){
  var colors = {
   "unknown":"#C5C5C5",
   "ok": "#B7E200",
   "warn": "#FAAA0C",
   "prob": "#F52201",
   "skip": "#C5C5C5"
  };
  var components = {
   device: {n:"device",t_id:"test_result_header_device",e:"unknown"}, internet: {n:"internet",t_id:"test_result_header_internet",e:"unknown"},
   router: {n:"wifi_router",t_id:"test_result_header_wifi_router",e:"unknown"},
   fixed_line: {n:"fixed_line",c1:"router",c2:"internet",t_id:"test_result_header_fixed_line",e:"unknown"},
   wifi: {n:"wifi",c1:"device",c2:"router",t_id:"test_result_header_wifi_network",e:"unknown"}
  };
  function get_component_name(c1,c2) {
   for(var comp in components)
    if(components[comp].c1 && components[comp].c2 && components[comp].c1 == c1, components[comp].c2 == c2) return comp;
  }
  function reset() {
   for(var comp in components) $("#lv_"+comp).css("background",colors.unknown);
  }
  function set_status(obj) {
   var comp = obj.c1;
   if(obj.c2) comp = get_component_name(obj.c1,obj.c2);
   if(components[comp] && components[comp].e) components[comp].e = obj.r;
   $("#lv_"+comp).css("background",colors[obj.r]);
  }
  function showSummary(warningInfo) {
  $("#lv_prob_desc").text(warningInfo);
  }
  function setSummary(errors,warnings,status) {
   if(status) {
    showSummary(status);
    return;
   }
   if(errors) showSummary(WTG.fmt(((errors>1)?_str('str_problems_found'):_str('str_problem_found')),{errors:errors}));
   else if(warnings) showSummary(WTG.fmt(((warnings>1)?_str('str_warnings_found'):_str('str_warning_found')),{warnings:warnings}));
   else showSummary(_str('str_all_good'));
  }
  return {
   reset:reset,
   set_status:set_status,
   components: components,
   setSummary: setSummary
  };
};

/* vim:set ts=4 sw=4 expandtab: */
